<template>
  <v-row justify="center" class="pointer">
    <img v-if="!pdf" id="frame" ref="previewImg" :src="image" :style="{height: heightImage + 'px', width: widthImage + 'px'}" alt="Invoice upload" @load="setSizes()">
    <pdf v-if="pdf" id="framePDF" ref="previewImg" :style="{max_height: heightImage + 'px', max_width: widthImage + 'px'}" :src="image" @loaded="setSizes()" />
  </v-row>
</template>

<script>
import pdf from 'vue-pdf';

export default {
    name: "InvoiceResizeImage",
    components: {
        pdf
    },
    props: {
        image: {
            type: String,
            default: null
        },
        pdf: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            heightImage: 500,
            widthImage: 700,
        };
    },
    methods: {
        setSizes ( ) {
            const img = this.$refs.previewImg;
            if (img) {
                const ratio = img.naturalWidth / img.naturalHeight;
                let width = img.clientHeight * ratio;
                let height = img.clientHeight;
                if (width > img.clientWidth) {
                    width = img.clientWidth;
                    height = img.clientWidth / ratio;
                }
                this.widthImage = (width * 400) / 450;
                this.heightImage = height;
            }
        },
    }
};
</script>

<style scoped>

</style>
